import { formatMessage } from 'model/message';
import { event } from 'model/notification';
const action = 'ENABLE_ROB';
const MIN_COINS = 2;
const MAX_COINS = 10;

const messageText = ({ gain }) => {
  return formatMessage('found a gun', { gain });
};
const notificationMessage = () => {
  return event(`the gun will need ammo`, 'its past is silent, its purpose... mine to decide.');
};

const attempt = () => {
  const result = {
    success: true,
    gain: {
      coins: Math.max(MIN_COINS, Math.ceil(Math.random() * MAX_COINS))
    },
    cost: {}
  };

  return result;
};

const executeSideEffects = (context, result) => {
  const { resources, history } = context.party;

  history.add({ action, result }, context);
  history.delta({ townDrunk: true, gun: true }, context);
  resources.delta({ ...result.gain }, context);

  return { message: messageText(result), notification: notificationMessage() };
};

const accidentallyRobDrunk = notifyDone => ({
  title: 'Collect Loot',
  hotkey: 'c',
  type: action,
  enabled: () => true,
  execute: context => {
    const result = attempt(context);
    const { message, notification } = executeSideEffects(context, result);

    notifyDone();
    return { result: { message }, notification };
  }
});

export default accidentallyRobDrunk;
